export default {"src":"/_next/static/media/syrian-arab-republic.19e176d1.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};